<template>
  <el-container class="admin-layout">
    <el-header class="admin-header">
      <span class="logo">Belinda 管理后台</span>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentTitle">{{ currentTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="header-right">
        <span class="nickname">{{ nickname }}</span>
        <el-button type="danger" size="small" @click="logout">退出</el-button>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px" class="admin-aside">
        <el-menu
          :default-active="activeMenu"
          router
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
          <el-menu-item index="/admin/dashboard">
            <el-icon><DataAnalysis /></el-icon>
            <span>仪表盘</span>
          </el-menu-item>
          <el-menu-item index="/admin/products">
            <el-icon><Goods /></el-icon>
            <span>产品管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/project-cases">
            <el-icon><Picture /></el-icon>
            <span>项目案例</span>
          </el-menu-item>
          <el-menu-item index="/admin/articles">
            <el-icon><Document /></el-icon>
            <span>文章管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/advantages">
            <el-icon><Star /></el-icon>
            <span>优势管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/examples">
            <el-icon><Collection /></el-icon>
            <span>案例管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/about">
            <el-icon><OfficeBuilding /></el-icon>
            <span>关于我们</span>
          </el-menu-item>
          <el-menu-item index="/admin/inquiries">
            <el-icon><Message /></el-icon>
            <span>询价管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/users">
            <el-icon><User /></el-icon>
            <span>管理员管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="admin-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      nickname: localStorage.getItem('admin_nickname') || '管理员',
    };
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    currentTitle() {
      return this.$route.meta.title || '';
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_nickname');
      this.$router.push('/admin/login');
    },
  },
};
</script>

<style scoped>
.admin-layout { height: 100vh; }
.admin-header {
  background: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
}
.logo { font-size: 18px; font-weight: bold; margin-right: 30px; }
.breadcrumb { flex: 1; }
.header-right { display: flex; align-items: center; gap: 10px; }
.nickname { color: #666; }
.admin-aside { background: #304156; overflow-y: auto; }
.el-menu { border-right: none; }
.admin-main { background: #f0f2f5; padding: 20px; }
</style>
